module.exports = __webpack_public_path__ + "static/media/multi-icon-2.ef4bbb2f.svg";